/**
 * Helpers for /connections/new-function (Edit-with-AI Function Developer).
 *
 * Extracted so the runtime→language mapping is unit-testable in
 * isolation. The bug pattern this protects (Bug #642) was a literal
 * comparison against `'python'` that never matched because the DB
 * stores the runtime as `'py'` (per the `tenant_functions` /
 * `functions` CHECK constraint — runtime IN ('ts','py')).
 *
 * Single source of truth — every caller that needs the editor
 * language for a stored function MUST go through this helper instead
 * of inlining the comparison.
 */

/** Editor language label rendered by Monaco / the Tool Developer pill. */
export type EditorLanguage = 'typescript' | 'python';

/**
 * Map a stored function runtime to the editor language label.
 *
 * The DB stores 'ts' or 'py' (b54 / bU4 CHECK constraint). Older mock
 * data sometimes uses 'python' / 'typescript' so the helper accepts
 * both forms case-insensitively, falling back to 'typescript' for
 * anything unrecognized (matches the historical default).
 */
export function runtimeToEditorLanguage(
  runtime: string | null | undefined,
): EditorLanguage {
  if (!runtime) return 'typescript';
  const r = runtime.toLowerCase();
  if (r === 'py' || r === 'python') return 'python';
  return 'typescript';
}
